import { gql } from '@apollo/client';

// Operation name `StudentPendingSurveys` is deliberately distinct from the
// backend field `mySurveys` — equal operation/field names make codegen collapse
// the generated result type into the schema payload type (graphql-codegen skill).
// The payload carries the full question list, so filling a survey needs no
// second request (spec 0011 §4).
export const StudentPendingSurveysQuery = gql`
  query StudentPendingSurveys {
    mySurveys {
      assignmentId
      title
      description
      groupName
      lessonName
      lessonNumber
      teacherName
      questions {
        id
        number
        text
        questionType
        required
        options
      }
    }
  }
`;

// Spec 0027 — the surveys the student has ALREADY submitted. A separate query,
// not a flag on `mySurveys`: the pending list is polled for the sidebar badge on
// every page, and the answer bodies would ride along on every one of those.
//
// Operation name is again distinct from the backend field for the codegen reason
// above.
export const StudentSubmittedSurveysQuery = gql`
  query StudentSubmittedSurveys {
    mySubmittedSurveys {
      responseId
      surveyTitle
      groupName
      lessonName
      lessonNumber
      submittedAt
      questions {
        id
        number
        text
        questionType
        required
        options
      }
      answers {
        questionId
        value
      }
    }
  }
`;
